import { ChangeItemChangeset } from '@app/types';
import { isMetadataKeyPath } from './isMetadataKeyPath';

const positionLeafKeys = new Set(['x', 'y']);

function isPositionKeyPath(key: readonly string[]): boolean {
  const lastKey = key[key.length - 1];

  return (
    positionLeafKeys.has(lastKey)
    && (
      // @see DesignModuleNode x & y.
      key.length === 1
      // @see DesignModuleLink.points array: `points[<index>].x | y`.
      || (
        key.length === 3
        && key[0] === 'points'
        && /[0-9]+/.test(`${key[1]}`)
      )
    )
  );
}

/**
 * Returns true if a changeset contains only "noise" changes — x/y coordinate
 * moves and/or metadata fields like author and timestamps that accompany any
 * edit. A changeset whose only real content is a metadata bump (e.g. author
 * re-saved without structural changes) is also considered noise and is
 * filtered by the merge dialog's "Hide position-only changes" toggle.
 */
export function isPositionOnlyChange(
  changeset: ChangeItemChangeset[] | undefined
): boolean {
  if (!changeset?.length) {
    return false;
  }

  return changeset.every((cs) => {
    return (
      ('key' in cs)
      && Array.isArray(cs.key)
      && cs.key.length
      && (isPositionKeyPath(cs.key) || isMetadataKeyPath(cs.key))
    );
  });
}
